<template>
<div>
    <div class="notice-wrap" v-if="config.loginNoticeShowMode=='2' && config.loginNoticeContent">
      <div class="laba-wrap" :style="{background:`#${config.schemeColor}`}">
        <img class="notice-img" src="@/assets/img/laba.svg" alt="">
      </div>
      <div>{{config.loginNoticeContent}}</div>
      <span class="watch" @click="openNotice" :style="{color:`#${config.schemeColor}`}">查看</span>
    </div>
            <!-- 通知公告弹框 -->
    <el-dialog
      modal-append-to-body
      append-to-body="true"
      class="notice-dialog-wrap"
      :visible.sync="noticeDialogVisible"
      width="450px"
      :before-close="closeNotice">
      <div class="notice-wrapper">
        <img class="notice-laba" src="@/assets/img/laba.png" alt="">
        <img class="notice-xuxian" src="@/assets/img/xuxian.png" alt="">
        <div class="notice-title">通知公告</div>
        <el-scrollbar>
          <div class="content">
                  <div v-for="(item,index) in loginNoticeContent" :key="index">{{item}}</div>
                </div>
        </el-scrollbar>
        <div class="notice-btn">
          <el-button size="small" plain round @click="noticeDialogVisible=false" :style="{color:`#${config.schemeColor}`,borderColor:`#${config.schemeColor}`,opacity:'0.8'}">我知道了</el-button>
        </div>
      </div>
    </el-dialog>
</div>
</template>

<script>
export default {
  props: [
    'i18n',
    'config',
  ],
  data: function data() {
    return {
      loginNoticeContent:[],
      noticeDialogVisible:false
    }
  },
  created: function created() {
  },
  mounted: function mounted() {
    this.loginNoticeContent = this.config.loginNoticeContent.split('\n')
  },
  methods:{
    openNotice: function openNotice(){
      this.noticeDialogVisible = true
    },
    closeNotice: function closeNotice() {
      this.noticeDialogVisible = false
    }
  }
}
</script>
